module.exports = __webpack_public_path__ + "img/0722043.png";